export default __webpack_public_path__ + "static/media/organization.b3974772.svg";